<template>
  <div class="uc-my-recmd bShadow-5">
    <el-tabs value="tj" class="ui-tabs ui-custom-s">
      <el-tab-pane name="tj">
        <span slot="label" class="lb-txt"> 我的推荐 </span>

        <!-- 推荐 -->
        <div v-show="!showNonePage" class="recmd-i-wrapper">
          <div class="recd-img">
            <img src="@/assets/image/recmd_top_header.png" alt="">
          </div>
          <div class="recd-ctn">
            <div class="recd-ctn-l" style="color:#333333; font-size:18px;">
              <div class="recd-ctn-l-i-w">
                <div class="recd-p-url"><img class="arrow-icon"/>专属地址：<span>{{this.referral.referralAddress}}</span></div>
                <div class="recd-p-code"><img class="arrow-icon"/>推荐码：<span>{{this.referral.referralCode}}</span></div>
                <div class="recd-p-info"><img class="goods-icon"/>分享好友并下单成功可获积分</div>
              </div>
            </div>
            <div class="recd-ctn-r">
              <div class="recd-c-qrcode">
                <div id="qrcode" ref="qrcode"></div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="showNonePage" class="none-pager">
          <img src="@/assets/image/order_none.png" alt="">
          <div>暂无推荐码</div>
          <p style="margin-top: 20px;line-height: 2">您还没有在平台购买过任何商品，购买成功后可获得您的<span style="color: #31A826;">专属推荐码;</span>
            <br> 再推荐其他用户下单可获<span style="color: #FF9D55">积分奖励</span>,赶快去下单吧
          </p>
          <el-button plain  icon="el-icon-suitcase-1" @click="goCategoryPage">去逛逛</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import API from '@/api/usr-api'
import QRCode from 'qrcodejs2'
export default {
  name: 'recommend',
  props: {

  },
  data () {
    return {
      referral: {},
      showNonePage: true

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {
    this.getRecommendInfo()
  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    async getRecommendInfo () {
      const res = await API.getRecommendInfo()
      this.referral = res.data.result
      if (this.referral.referralCode) {
        this.showNonePage = false
      }
      this.qrcode()
    },
    qrcode (res) {
      let qrcode = new QRCode('qrcode', {
        width: 120, // 设置宽度，单位像素
        height: 120, // 设置高度，单位像素
        text: this.referral.referralQr // 设置二维码内容或跳转地址
      })
      console.log(qrcode)
    },
    goCategoryPage () {
      this.$router.push({ name: 'index', params: { } })
    }

  },
  components: {

  }
}
</script>

<style lang="stylus">
  .none-pager
    text-align center
    padding-top 60px
.uc-my-recmd
  height 666px
  box-sizing border-box
  background-color #ffffff
  overflow hidden
  .recmd-i-wrapper
    .recd-img
      height 180px
      overflow hidden
      margin 14px 30px 18px
      img
        display inline-block
        width 100%
        height 100%
    .recd-ctn
      flex-ltr-parent()
      margin 0px 80px
      >div
        width 50%
        height 300px
      .recd-ctn-l
        width 60%
        center()
        .recd-ctn-l-i-w
          width 100%
          font-size 18px
          font-weight normal
          .arrow-icon
            content:  url("../../assets/image/right.png")
            padding 0 10px
          .goods-icon
            content: url("../../assets/image/goods.png")
            padding 0 10px
          .recd-p-url
            max-width 80%
            padding-bottom 10px
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            span
              color #000000
          .recd-p-code
            padding-bottom 10px
            span
              color #000000
          .recd-p-info
              color:#FC2A34;
              font-size:18px;
          &>div
            height 40px
      .recd-ctn-r
        flex-left()
        width 40%
</style>
